import type {MatchCandidate,Omonimo} from "../../api";
export function formatScore(score: number): string {
  return `${Math.round(score * 100)}/100`;
}

/** detail.link è dato scraped: renderizzarlo come href solo se http(s), mai
 * schemi arbitrari (es. javascript:) arrivati da un adapter permissivo. */
export function isHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

/** Chiave di identità di un omonimo: CF quando presente, altrimenti i campi
 * anagrafici (le righe legacy possono non avere CF ma vanno comunque abbinate
 * al candidate corrispondente). */
function omonimoKey(o: Omonimo): string {
  const cf = (o.cf || "").replace(/\s+/g, "").toUpperCase();
  if (cf) return `cf:${cf}`;
  return [
    (o.cognome || "").trim().toUpperCase(),
    (o.nome || "").trim().toUpperCase(),
    (o.data || "").trim(),
    (o.luogo || "").trim().toUpperCase(),
  ].join("|");
}

interface OmonimoRow {
  omonimo: Omonimo;
  cand: MatchCandidate | null;
}

/** Righe della tabella omonimi in ordine di score: prima i candidates (già
 * ordinati per score desc), poi gli omonimi non coperti dal lookup. Le righe
 * persistite prima dell'ordinamento in fase di persist arrivano in ordine
 * pagina SISTER, quindi l'ordine dei candidates è l'unica fonte affidabile. */
export function buildOmonimoRows(omonimi: Omonimo[], candidates: MatchCandidate[]): OmonimoRow[] {
  const used = new Set<number>();
  const rows: OmonimoRow[] = [];
  for (const cand of candidates) {
    const key = omonimoKey(cand.omonimo);
    const idx = omonimi.findIndex((o, i) => !used.has(i) && omonimoKey(o) === key);
    if (idx < 0) continue;
    used.add(idx);
    rows.push({ omonimo: omonimi[idx], cand });
  }
  omonimi.forEach((o, i) => {
    if (!used.has(i)) rows.push({ omonimo: o, cand: null });
  });
  return rows;
}

